// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import myw from 'myWorld-base';
import userGroupsHtml from 'text!html/userGroups.html';
import 'myWorld/uiComponents/dialog';
import 'myWorld/controls/userGroups/userGroupForm';

myw.UserGroupEditor = myw.Dialog.extend({
    id: 'user-group-editor',
    tagName: 'ul',
    className: 'list',

    options: {
        modal: true,
        autoOpen: true,
        destroyOnClose: true,
        minWidth: 490,
        position: { my: 'center', at: 'top', of: window },
        buttons: {
            Update: {
                text: '{:update}',
                class: 'primary-btn',
                click() {
                    this.updateGroup();
                }
            },

            Delete: {
                text: '{:delete}',
                click() {
                    this.deleteGroup();
                }
            },

            Close: {
                text: '{:close_btn}',
                class: 'right',
                click() {
                    this.close();
                }
            }
        }
    },

    initialize(options) {
        this.owner = options.owner;
        this.app = this.owner.app;
        this.system = options.system;
        options.model = options.groupId;

        myw.Dialog.prototype.initialize.call(this, options);
    },

    render() {
        return this.system.getGroup(this.options.groupId).then(group => {
            this.group = group;

            this.form = new myw.UserGroupForm({
                owner: this,
                model: group
            });

            this.translate(this.$el);
            this.delegateEvents();

            this.options.contents = this.form.$el;
            this.options.title = `${this.msg('group_editor_title')} ${group.name}`;
            myw.Dialog.prototype.render.call(this);

            return this.form.$el;
        });
    },

    getValues(argument) {
        return this.form.getValues();
    },

    updateGroup() {
        const groupData = this.getValues();
        this.$('.primary-btn').attr('disabled', true);
        //and display an information message
        this.form.displayMessage(this.msg('saving'), 'alert');
        this.system.updateGroup(this.options.groupId, groupData).then(argument => {
            // this.toggleSaveButton(false);
            this.form.displayMessage(this.msg('saved'));
            setTimeout(() => {
                this.owner.populateGroupsList();
                this.close();
            }, 1000);
        });
    },

    deleteGroup() {
        const that = this,
            deleteConfirmation = $(`<div>${this.msg('confirm_delete_message')}</div>`)
                .appendTo('body')
                .dialog({
                    modal: true,
                    resizable: false,
                    title: this.msg('confirm_delete_title'),
                    buttons: {
                        OK: {
                            text: this.msg('ok_btn'),
                            click() {
                                $(this)
                                    .dialog('destroy')
                                    .remove();
                                that._confirmedDelete();
                            }
                        },
                        Cancel: {
                            text: this.msg('cancel_btn'),
                            class: 'right',
                            click() {
                                $(this)
                                    .dialog('destroy')
                                    .remove();
                            }
                        }
                    }
                });
        deleteConfirmation
            .dialog('widget')
            .find('.ui-dialog-buttonset')
            .css('float', 'none');
    },

    async _confirmedDelete() {
        await this.system.deleteGroup(this.options.groupId);
        this.form.displayMessage(this.msg('deleted_ok', { title: this.group.name }));
        await Promise.delay(1000);
        this.close();
        this.owner.populateGroupsList();
    }
});

export default myw.UserGroupEditor;
